module.exports = __webpack_public_path__ + "static/media/printer_dot.5c14e11f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/pricing/printer_dot.png
 ** module id = 652
 ** module chunks = 0
 **/